
import { useState } from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { DeviceGroupedAssignmentTable } from "@/components/devices/DeviceGroupedAssignmentTable";
import { AddAssignmentSection } from "@/components/devices/AddAssignmentSection";
import { useSuperuserGuard } from "@/hooks/use-superuser-guard";
import { FixedPageHeader } from "@/components/ui/fixed-page-header";
import { PAGE_HEADERS } from "@/constants/page-headers";

const DeviceAssignments = () => {
  const { isLoading, isSuperuser } = useSuperuserGuard();
  const [quickAddDevice, setQuickAddDevice] = useState<{
    deviceId: string;
    deviceName: string;
  } | null>(null);
  
  const handleDeviceAdded = () => {
    setQuickAddDevice(null); // Clear quick add state
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!isSuperuser) {
    return null; // useSuperuserGuard will redirect
  }

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-background">
        <AppSidebar />
        <main className="flex-1">
          <FixedPageHeader {...PAGE_HEADERS.deviceAssignments} />
          <div className="p-8 space-y-8" style={{ paddingTop: "8.5rem" }}>
            <AddAssignmentSection 
              onAssignmentAdded={handleDeviceAdded}
              prefilledDeviceId={quickAddDevice?.deviceId}
              prefilledDeviceName={quickAddDevice?.deviceName}
            />
            <DeviceGroupedAssignmentTable 
              quickAddDevice={quickAddDevice}
              onQuickAddDeviceChange={setQuickAddDevice}
            />
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
};

export default DeviceAssignments;
